import { Component, OnInit } from '@angular/core';

import { BillboardService } from '../billboard-service/billboard.service';
import { EventsService } from '../../core/services/events-service/events.service';
import { Event } from '../../events/interfaces';
import { Billboard } from '../billboard.interface';

@Component({
	selector: 'eze-live',
	templateUrl: './live.component.html',
	styleUrls: ['./live.component.css']
})
export class LiveComponent implements OnInit {
	eventData: Event = null;
	billboard: Billboard = null;
	time = 0;

	constructor(
		private billboardService: BillboardService,
		private eventService: EventsService
	) {}

	ngOnInit() {
		this.getEventData();
		this.getBillboardData();
		setInterval(() => {
			this.tick();
		}, 1000);
	}

	tick() {
		this.time++;
		if (this.time % 60 === 0) {
			this.getBillboardData();
		}
	}

	get countdown() {
		return 60 - (this.time % 60);
	}

	getEventData() {
		this.eventService.getEvent('jki30th').subscribe(
			(res: Event) => {
				this.eventData = res;
			},
			err => {
				console.log('err =', err);
			}
		);
	}

	bracketLink(groupNumber) {
		const fix_me = 'jki30th';
		return `/api/v1/events/${fix_me}/groups/${groupNumber}`;
	}

	getBillboardData() {
		this.billboardService.getBillboardData().subscribe(
			(res: Billboard) => {
				this.billboard = res;
			},
			err => {
				console.log('err =', err);
			}
		);
	}
}
